//@flow
import React from 'react';
import {getBasicDomain} from '../../../utils/component';
import DomainConfiguration from '../../configure/general/components/DomainConfiguration';

import type {Store, User, Domain as DomainEntity} from '../../../entities';

import type {SaveGeneralSettingsRequest} from '../../configure/general/api';
import {IconButton, makeStyles} from '@material-ui/core';
import {WhatsApp} from '@material-ui/icons';

type Props = {
  customDomain?: DomainEntity,
  store?: Store,
  user?: User,
  validationResult?: boolean,
  isValidating?: boolean,
  domainChangeToken: string,
  isValidatingSsl?: boolean,
  sslIsValid?: boolean,
  errorValidatingSsl?: string,
  isGeneratingSsl: boolean,
  startGeneratingSsl?: boolean,

  saveGeneralSettings: ({dataGeneral: SaveGeneralSettingsRequest}) => void,
  errorGeneratingSsl?: string,
  getDomainChangeToken: () => void,
  validateDomain: ({subdomain: string}) => void,
  validateSsl: ({domain: string}) => void,
  generateSsl: ({domain: string}) => void,
  getCustomDomain: ({storeId: string}) => void,
  deleteCustomDomain: () => void,
  domainDeleted: boolean,
};

const useStyles = makeStyles(theme => ({
  whatsAppBtn: {
    background: '#25D366',
    color: '#fff',
    position: 'fixed',
    bottom: '80px',
    right: '20px',
    zIndex: 999,
    transition: 'transform 0.3s ease',
    boxShadow:
      '0px 0px 2px rgba(40, 41, 61, 0.04), 0px 4px 8px rgba(96, 97, 112, 0.16);',
    '&:hover': {
      background: '#25D366',
      transform: 'scale(1.1)',
    },

    '&:active': {
      transform: 'scale(0.9)',
    },

    [theme.breakpoints.up('md')]: {
      position: 'relative',
      bottom: 0,
      right: 0,
    },
  },
  footer: {
    marginTop: theme.spacing(2),
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default function Domain(props: Props) {
  const {
    store,
    saveGeneralSettings,
    validateDomain,
    validationResult,
    isValidating,
    getDomainChangeToken,
    domainChangeToken,
    isValidatingSsl,
    sslIsValid,
    isGeneratingSsl,
    errorGeneratingSsl,
    errorValidatingSsl,
    validateSsl,
    generateSsl,
    startGeneratingSsl,
    customDomain,
    getCustomDomain,
    user,
    deleteCustomDomain,
    domainDeleted,
  } = props;

  const classes = useStyles();

  if (!store || !(!!user && user.type === 'vendor-user')) return null;
  const whatsappUrl =
    'https://api.whatsapp.com/send?phone=51972076020&text=Hola%20TiendaDa%2C%20necesito%20ayuda%20con%20el%20dominio.';

  return (
    <>
      <DomainConfiguration
        domain={getBasicDomain(store.domains)}
        saveGeneralSettings={saveGeneralSettings}
        validateDomain={validateDomain}
        validationResult={validationResult}
        isValidating={isValidating}
        getDomainChangeToken={getDomainChangeToken}
        domainChangeToken={domainChangeToken}
        isValidatingSsl={isValidatingSsl}
        sslIsValid={sslIsValid}
        isGeneratingSsl={isGeneratingSsl}
        errorGeneratingSsl={errorGeneratingSsl}
        errorValidatingSsl={errorValidatingSsl}
        validateSsl={validateSsl}
        generateSsl={generateSsl}
        startGeneratingSsl={startGeneratingSsl}
        customDomain={customDomain}
        getCustomDomain={getCustomDomain}
        storeId={store.id}
        deleteCustomDomain={deleteCustomDomain}
        domainDeleted={domainDeleted}
      />
      <footer className={classes.footer}>
        <IconButton
          className={classes.whatsAppBtn}
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <WhatsApp />
        </IconButton>
      </footer>
    </>
  );
}
